export default __webpack_public_path__ + "static/media/add-express-contract.c566ee44.png";